export default __webpack_public_path__ + "static/media/5.25631d83.webp";